<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong> Declaration AT CeV </strong>
      </b-card-header>
      <b-card-body>
        <h6>Recherche d'un SIREN</h6>
        <b-row class="mt-3">
          <b-col sm="5">
            <b-form-group
              label-for="siren"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>SIREN</b></template>
              <b-form-input type="text"
                            id="siren"
                            class="custom-input-reduit"
                            v-model="siren">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="5">
            <b-form-group
              label-for="dateDebut"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>Date de début :</b></template>
              <b-form-input class="custom-input-reduit"
                            type="date"
                            id="dateDebut"
                            @paste="onPaste($event, 'debut')"
                            v-model="dateDebut"
                            :class="{hasError: errors.date_debut !== ''}">
              </b-form-input>
              <span class="field-error">{{ errors.date_debut }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="5">
            <b-form-group
              label-for="dateFin"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>Date de fin :</b></template>
              <b-form-input type="date"
                            id="dateFin"
                            @paste="onPaste($event, 'fin')"
                            v-model="dateFin">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-form-group v-if="statusReady"
                          :label-cols="1"
                          :horizontal="true">
              <template slot="label">
                <b>Prest'IJ</b>
              </template>
              <b-form-checkbox-group v-model="selectedStatus" class="ml-4">
                <b-form-checkbox v-for="status in allStatus"
                                 :value="status.id"
                                 :key="status.id"
                                 class="ml-2 mt-2">
                  {{ status.libelle }}
                </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-form-group :label-cols="1"
                          :horizontal="true">
              <template slot="label">
                <b>Chargement SIRH</b>
              </template>
              <b-form-checkbox-group v-model="selectedChargementSirh" class="ml-4">
                <b-form-checkbox value="oui" class="ml-2 mt-2">OUI</b-form-checkbox>
                <b-form-checkbox value="non" class="ml-2 mt-2">NON</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-form-group :label-cols="2" :horizontal="true">
              <template slot="label">
                <b>Ouverture simplifié</b>
              </template>
              <b-form-checkbox-group v-model="selectedOuverture" class="ouverture-checkbox">
                <b-form-checkbox value="oui" class="ml-2 mt-2">OUI</b-form-checkbox>
                <b-form-checkbox value="non" class="ml-2 mt-2">NON</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
        <div>
          <b-button class="mt-2 mb-1 mr-1" variant="info" @click="generateExcel">Génerer</b-button>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";

  export default {
    name: "DeclarationAtCev",
    data() {
      return {
        siren: null,
        dateDebut: null,
        dateFin: null,
        allStatus: [],
        selectedStatus: [],
        selectedOuverture: [],
        selectedChargementSirh: [],
        statusReady: false,
        errors: {
          date_debut: '',
          siren: '',
        }
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.getStatusPrestij();
    },
    methods: {
      generateExcel() {
        let self = this;
        const data = {
          siren: this.siren,
          date_debut: this.dateDebut,
          date_fin: this.dateFin,
          prestij: this.selectedStatus,
          sirh: this.selectedChargementSirh,
          ouverture: this.selectedOuverture,
        };
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .post('/espaceGestion/extractions/siren_at_cev', data, {responseType: "arraybuffer"})
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            this.downloadExportedFile(response, 'declaration_at_cev.xlsx');
          }).catch(function(error){
                console.log(error)
                self.$store.commit('IS_LOADING', false)
                self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue lors de la génération du fichier. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
              });
      },
      downloadExportedFile(response, filename) {
        let newBlob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        const data = window.URL.createObjectURL(newBlob);
        let link = document.createElement('a');
        link.href = data;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(function () {
          window.URL.revokeObjectURL(data);
        }, 100)

      },
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      onPaste(evt, type) {
        evt.stopPropagation();
        evt.preventDefault();
        let clipboardData = evt.clipboardData || window.clipboardData;
        let pastedData = clipboardData.getData('Text');
        pastedData = moment(pastedData, 'DD/MM/YYYY').format('YYYY-MM-DD');
        if (type === 'debut') {
          this.dateDebut = this.formatDate(pastedData);
        } else if (type === 'fin') {
          this.dateFin = this.formatDate(pastedData);
        }
      },
      getStatusPrestij() {
        this.$axios
          .get("/espaceGestion/dossier/getStatusPrestij")
          .then(response => {
            this.allStatus = response.data.data;
            this.statusReady = true;
          });
      }
    }
  }
</script>

<style scoped>
  @media ( min-width : 992px ) {
    .ouverture-checkbox {
      margin-left: -110px !important;
    }
  }
</style>
